import { useCallback, useContext } from 'react';
import { EffectContext } from '../../../../../common/view/effect/effect.context';
import { MonoIcon } from '../../../../../common/view/icon/mono/mono-icon';
import { ServerApi } from '../../../../../external/server/server.api';
import { ArrayFuncs } from '../../../../../foundation/js/array.funcs';
import { BasicNodeSubWireFuncs } from '../../../../core/node/basic-node-sub.wire.funcs';
import { NodeStore } from '../../../../core/node/node.store';
import { AppStore } from '../../../app/app.store';
import { EffectMenuItem } from '../../effect-menu-item';

export function TodayEffectMenuItem({ nodeId }: { nodeId: string }) {
  const appStore = AppStore.use();
  const todayNode = NodeStore.useItem(appStore.todayNodeId);
  const sub = ArrayFuncs.ensure(todayNode?.sub);
  const { popupApi } = useContext(EffectContext);

  const isSelected = sub.includes(nodeId);

  const handleClick = useCallback(() => {
    popupApi.pop();
    if (!nodeId) {
      return;
    }

    if (isSelected) {
      BasicNodeSubWireFuncs.removeItem(sub, { child: nodeId });
    } else {
      BasicNodeSubWireFuncs.addItem(sub, { child: nodeId });
    }

    NodeStore.updateItem(appStore.todayNodeId!, { sub });
    ServerApi.updateNode(appStore.todayNodeId!, { sub });
  }, [nodeId, isSelected, todayNode]);

  if (isSelected) {
    return <></>;
  }

  return <EffectMenuItem icon={MonoIcon.today} iconColor={'#FFCE1B'} title={'Add to Today'} subtitle={'Take out the trash today'} onClick={handleClick} />;
}
